import { render, staticRenderFns } from "./FormContratoArrendamiento.vue?vue&type=template&id=43f24350&"
import script from "./FormContratoArrendamiento.vue?vue&type=script&lang=ts&"
export * from "./FormContratoArrendamiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports